import { Plate } from '../models/plate';

export class PlateAnnouncementDTO{
    labID: string;
    newPlates: Plate[];
    receivedPlates: string[];
    puid: string;
}